//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section` 
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    & p {
        color: var(--light-gray-5);
        font-size: 14px;
        margin: 0;
    }
`;
export const Header = styled.header` 
    display: flex;
    flex-direction: column;
    gap: 16px;
    & h3 {
        color: var(--dark-4);
        font-size: 20px;
        margin: 0;
    }
    margin-bottom: 15px;
`;
export const Content = styled.section` 
    display: flex;
    flex-direction: column;
    gap: 25px;
`;
export const Step = styled.div` 
    display: flex;
    flex-direction: column;
    gap: 10px;
    & h4, & p {
        color: var(--light-gray-5);
    }
    & h4 {
        font-size: 16px;
        margin: 0;
    }
`;
export const Footer = styled.section` 
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const Annotation = styled(Step)` 
    & h4, & p {
        color: var(--purple-4);
    }
`;